/**
 * 公共接口结果类
 */
export declare interface TemplateResultClass {
  /**
   * 后台返回状态码
   */
  code: number;
  /**
   * 后台返回消息
   */
  msg: string;
}

/**
 * 公共分页类
 */
export declare interface pagination {
  /**
   * 页码
   */
  pageIndex: number;
  /**
   * 分页大小
   */
  pageSize: number;
  /**
   * 总数量
   */
  totalCount: number;
}

/**
 * 当前文件请求接口头地址
 */
export const urlDesignFaceTeachActivity = '/api/XOrg/BookMaterial/';

/**
 * 获取活动列表
 */
export const urlGetFaceTeachActivityList = urlDesignFaceTeachActivity + 'GetFaceTeachActivityList';

/**
 * 添加面授活动
 */
export const urlAddFaceTeachActivity = urlDesignFaceTeachActivity + 'AddFaceTeachActivity';

/**
 * 删除面授活动
 */
export const urlDeleteFaceTeachActivity = urlDesignFaceTeachActivity + 'DeleteFaceTeachActivity';

export const urlStartActivity = urlDesignFaceTeachActivity + 'StartFaceTeachActivity';

export const urlEndActivity = urlDesignFaceTeachActivity + 'EndFaceTeachActivity';

export const urlRestartActivity = urlDesignFaceTeachActivity + 'RestartFaceTeachActivity';

export const urlEditFaceTeachActivity = urlDesignFaceTeachActivity + 'EditFaceTeachActivity';

export const urlAddSource = urlDesignFaceTeachActivity + 'AddSource';

export const urlDeleteSource = urlDesignFaceTeachActivity + 'DeleteSource';

export const urlnotSignedStu = urlDesignFaceTeachActivity + 'notSignedStu';

export const urlRemoveStartFaceTeachActivity = urlDesignFaceTeachActivity + 'RemoveStartFaceTeachActivity';

export const urlgetSignStatic = urlDesignFaceTeachActivity + 'getSignStatic';

export const urlgetStudentSigned = urlDesignFaceTeachActivity + 'getStudentSigned';



/**
 * 获取资源列表
 */
export const urlGetSourceList = urlDesignFaceTeachActivity + 'GetSourceList';

import http from 'lib//http';

/**
 * 获取活动列表结果集
 */
export class FaceTeachActivityList implements TemplateResultClass {
  code: number;
  msg: string;
  list: {
    id: string;
    activityName: string;
    dateCreated: string;
    activityContent: string;
    dataJson: string;
    voteType: string;
    activityType: string;
    activityState: string;
    activityRemake: string;
    startDate: string;
    endDate: string;
    paperId: string;
    PaperType: string;
    docJson: string;
  }[];
  pagination: pagination;
}

/**
 * 获取活动列表
 * @param courseId 课程Id
 * @param classId 班级Id
 * @param signName 活动名称
 * @param page 页码
 */
export function GetFaceTeachActivityList(faceId: string, classState: string, activityName?: string, activityType?: string, page?: number) {

  return http.post<FaceTeachActivityList>(urlGetFaceTeachActivityList, {
    faceId,
    classState,
    activityName,
    activityType,
    page
  });
}

/**
 * 添加面授活动
 * @param courseId 课程Id
 * @param classId 班级Id
 * @param faceId 面授Id
 * @param signName 活动名称
 */
export function AddFaceTeachActivity(
  courseId: string,
  classId: string,
  faceId: string,
  faceTeachState: string,
  activityName: string,
  activityContent: string,
  voteType: string,
  dataJson: string,
  activityType: string,
  ActivityRemake: string,
  questionType: number,
  paperId: string,
  docJson: string,
  CreateIn: number,
  signType?: number,
  RandNum?: string,
  allowQuestionNum?: number,
  EndDate?: Date,
  StartDate?: Date,
  AllowVoteNum?:number
) {
  return http.post<TemplateResultClass>(urlAddFaceTeachActivity, {
    courseId,
    classId,
    faceId,
    faceTeachState,
    activityName,
    activityContent,
    voteType,
    dataJson,
    activityType,
    ActivityRemake,
    questionType,
    paperId,
    docJson,
    CreateIn,
    signType,
    RandNum,
    allowQuestionNum,
    EndDate,
    StartDate,
    AllowVoteNum
  });
}

/*
*Excel导入面授活动
*/
export const urlbatchAddFaceTeachActivity = urlDesignFaceTeachActivity + 'BatchAddFaceTeachActivity';

export function BatchAddFaceTeachActivity(Ids: string[], classId: string, faceId: string, faceTeachState: string, activityType: string, createIn: number) {
  return http.post<TemplateResultClass>(urlbatchAddFaceTeachActivity, {
    Ids,
    classId,
    faceId,
    faceTeachState,
    activityType,
    createIn
  });
}

export const urlGetClassAllStudent = urlDesignFaceTeachActivity + 'getClassAllStudent';

export class GetClassAllStudent {
  list: {
    studentId: String;
    studyNumber: String;
    classId: String;
  }[];
}
/**
 * 获取班级成员信息
 */
export function getClassAllStudent(classId: string, faceId: string) {
  return http.post<GetClassAllStudent>(urlGetClassAllStudent, {
    classId,
    faceId
  });
}

export const urlupdateSignState = urlDesignFaceTeachActivity + 'updateSignState';

/**
 * 更新签到状态
 */
export function updateSignState(studentId: string, activityId: string, signState: number) {
  return http.post<TemplateResultClass>(urlupdateSignState, {
    studentId,
    activityId,
    signState
  });
}

export const urlshowSignedStuCount = urlDesignFaceTeachActivity + 'showSignedStuCount';

export class ShowSignedStuCount {
  count: number;
}

/**
 * 获取签到学生数量
 */
export function showSignedStuCount(activityId: string) {
  return http.post<ShowSignedStuCount>(urlshowSignedStuCount, {
    activityId
  });
}

/**
 * 删除面授活动
 * @param Ids 面授活动Id
 */
export function DeleteFaceTeachActivity(Ids: string[]) {
  return http.post<TemplateResultClass>(urlDeleteFaceTeachActivity, {
    Ids
  });
}

// 开始活动
export function StartFaceTeachActivity(Id: string) {
  return http.post<TemplateResultClass>(urlStartActivity, {
    Id
  });
}

// //停止活动
export function EndFaceTeachActivity(Id: string) {
  return http.post<TemplateResultClass>(urlEndActivity, {
    Id
  });
}

// //重启活动
export function RestartActivity(Id: string) {
  return http.post<TemplateResultClass>(urlRestartActivity, {
    Id
  });
}

/**
 * 修改面授投票
 * @param faceId 面授投票Id
 * @param voteName 面授投票名称
 * @param voteContent 面授投票内容
 * @param voteType 面授投票类型
 * @param dataJson 面授投票选项json
 */
export function EditFaceTeachActivity(
  activityId: string,
  activityName: string,
  activityContent: string,
  voteType?: string,
  dataJson?: string,
  paperId?: string,
  docJson?: string,
  StartDate?: string,
  EndDate?: string,
  AllowVoteNum?:number
) {
  return http.post<TemplateResultClass>(urlEditFaceTeachActivity, {
    activityId, activityName, activityContent, voteType, dataJson, paperId, docJson, StartDate, EndDate,AllowVoteNum
  });
}

//添加资源
export function AddSource(ids: string[], faceId: string, classId: string, courseId: string, faceTeachState: string, activityType: string, createIn?: number) {
  return http.post<TemplateResultClass>(urlAddSource, {
    ids,
    faceId,
    classId,
    courseId,
    faceTeachState,
    activityType,
    createIn
  });
}

//删除资源
export function DeleteSource(activtyId: string, faceId: string, classId: string, courseId: string) {
  return http.post<TemplateResultClass>(urlDeleteSource, {
    activtyId,
    faceId,
    classId,
    courseId
  });
}

export class FaceTeachName {
  FaceTeachName: string;
}

export const urlFaceTeachName = urlDesignFaceTeachActivity + 'FaceTeachName';

//获取授课名称
export function GetFaceTeachName(faceId: string) {
  return http.post<FaceTeachName>(urlFaceTeachName, {
    faceId
  });
}

export class StatisticalActivities implements TemplateResultClass {
  code: number;
  msg: string;
  list: {
    ActivityId: string;
    CourseId: string;
    ActivityType: string;
    ActivityStartDate: string;
    ActivityCreatedDateTime: string;
  }[];
}

export const urlStatisticalActivities = urlDesignFaceTeachActivity + 'StatisticalActivities';

// 获取授课活动过程
export function GetStatisticalActivities(classId: string, faceId: string) {
  return http.post<StatisticalActivities>(urlStatisticalActivities, {
    classId,
    faceId
  });
}

export const urlStatisticalAllActivities = urlDesignFaceTeachActivity + 'StatisticalAllActivities';
// 获取全部授课活动过程
export function GetStatisticalAllActivities(classId: string, faceId: string) {
  return http.post<StatisticalActivities>(urlStatisticalAllActivities, {
    classId,
    faceId
  });
}

export const urlSubmitFaceTeachFeedBack = urlDesignFaceTeachActivity + 'SubmitFaceTeachFeedBack';

export function SubmitFaceTeachFeedBack(faceId: string, courseId: string, classId: string, Summary: string, Abnormal: string[], Remark: string) {
  return http.post<TemplateResultClass>(urlSubmitFaceTeachFeedBack, {
    faceId,
    courseId,
    classId,
    Summary,
    Abnormal,
    Remark
  });
}

export const urlFaceTeachSummary = urlDesignFaceTeachActivity + 'FaceTeachSummary';

export class FaceTeachSummary implements TemplateResultClass {
  code: number;
  msg: string;
  list: {
    StuNum: String;
    StuName: String;
    ClassName: String;
    IsSummary: String;
    Start: number;
    SummaryContent: String;
    Score: String;
  }[];
  data: {
    name: string;
    value: number;
  }[];
}
export function FaceTeachSummaryList(faceId: string, seachStuName: string, seachStuNum: string) {
  return http.post<FaceTeachSummary>(urlFaceTeachSummary, {
    faceId,
    seachStuName,
    seachStuNum
  });
}

export const urlFaceTeachEvaluate = urlDesignFaceTeachActivity + 'FaceTeachEvaluate';

export class FaceTeachEvuluate implements TemplateResultClass {
  code: number;
  msg: string;
  list: {
    StuNum: String;
    StuName: String;
    ClassName: String;
    IsEvaluate: String;
    Start: number;
    EvaluateContent: String;
    Score: String;
  }[];
  data: {
    name: string;
    value: number;
  }[]
}

export function FaceTeachEvuluateList(faceId: string, seachStuName?: string, seachStuNum?: string) {
  return http.post<FaceTeachEvuluate>(urlFaceTeachEvaluate, {
    faceId,
    seachStuName,
    seachStuNum
  });
}

export const urlDoScore = urlDesignFaceTeachActivity + 'doScore';

export function DoScore(ids: string[], score: number) {
  return http.post<TemplateResultClass>(urlDoScore, {
    ids,
    score
  });
}

export const urlFaceTeachPerformance = urlDesignFaceTeachActivity + 'FaceTeachPerformance';

export class FaceTeachPerformance implements TemplateResultClass {
  code: number;
  msg: string;
  list: {
    StuNum: String;
    StuName: String;
    ClassName: String;
    SignNum: String;
    PartInNum: String;
    Score: String;
  }[];
}

export function FaceTeachPerformanceList(faceId: string, seachStuName: string, seachStuNum: string) {
  return http.post<FaceTeachPerformance>(urlFaceTeachPerformance, {
    faceId,
    seachStuName,
    seachStuNum
  });
}

export const urldoScorePerformance = urlDesignFaceTeachActivity + 'doScorePerformance';

export function doScorePerformance(ids: string[], score: number) {
  return http.post<TemplateResultClass>(urldoScorePerformance, {
    ids,
    score
  });
}

export class getSignName implements TemplateResultClass {
  code: number;
  msg: string;
  signName: string;
}

export const urlgetSignName = urlDesignFaceTeachActivity + 'getSignName';

export function GetSignName(activityId: string) {
  return http.post<getSignName>(urlgetSignName, {
    activityId
  });
}

export const urlupdateSignName = urlDesignFaceTeachActivity + 'UpdateSignName';

export function UpdateSignName(activityId: string, signName: string) {
  return http.post<TemplateResultClass>(urlupdateSignName, {
    activityId,
    signName
  });
}

export const urlDeleteSigned = urlDesignFaceTeachActivity + 'DeleteSigned';

export interface IPaperStuOnLineList {
  code: number;
  msg: string;
  count: string;
  list: {
    Id: string;
    CreateDisplayName: string;
    ActivityName: string;
    ActivityContent: string;
    PaperId: string;
    ActivityState: string;
  }[];
}

export function DeleteSigned(activityId: string) {
  return http.post<TemplateResultClass>(urlDeleteSigned, {
    activityId
  });
}



export const urlgetOnlinePaperList = urlDesignFaceTeachActivity + 'getOnlinePaperList';

export function getOnlinePaperList(courseId: string, classId: string, faceId: string, page?: number,pageSize?: number) {
  return http.post<IPaperStuOnLineList>(urlgetOnlinePaperList, {
    courseId,
    classId,
    faceId,
    page,
    pageSize
  })
}

//未参与总结、评教学生统计请求配置
export const urlAbsentStu = '/api/XOrg/FaceTeachActivity/AbsentStu';
export interface AbsentStuRequest {
  code: string;
  msg: string;
  AbsentStuList: {
    Id: string,
    CreateUserId: string,
    CreateNum: string,
    CreateDisplayName: string,
    ClassName: string,
  }[];
  pagination:
  {
    pageIndex: string;
    pageSize: string;
    totalCount: string;
  };
}
export function AbsentStu(faceId: string, ActitvityType: number) {
  return http.post<AbsentStuRequest>(urlAbsentStu,
    {
      faceId,
      ActitvityType
    });
}

/*--------------------------------------------获取测验列表----------------------------------------------------------------- */
export const urlGetPaperList = urlDesignFaceTeachActivity + 'getPaperList';

export interface IGetPaperList {
  code: string;
  list: {
    Id: string;
    DateCreated: string;
    CreatorName: string;
    PaperName: string;
    CourseName: string;
    QuestionCount: number;
    TotalScore: string;
    PaperType: number;
  }[];
  pagination: {
    pageIndex: string;
    pageSize: string;
    totalCount: string;
  };
}

// 获取测验列表
export function GetPaperList(courseId: string, paperType: string, page?: string, paperName?: string , pageSize?: number) {
  return http.get<IGetPaperList>(urlGetPaperList, {
    params: {
      paperType,
      courseId,
      page,
      paperName,
      pageSize
    }
  });
}

// 获取统计分析数据
export interface ICourseAnalysis {
  code: number;
  msg: string;
  list: {
    Id: string;
    ActivityType: string;
    ActivityName: string;
    count: number;
  }[];
}

export const urlCourseAnalysis = urlDesignFaceTeachActivity + 'CourseAnalysis';

export function getCourseAnalysis(classId: string) {
  return http.post<ICourseAnalysis>(urlCourseAnalysis, {
    classId
  })
}

export const urlActivitylist = urlDesignFaceTeachActivity + 'Activitylist';

export function getActivitylist(classId: string, ActivityType: number) {
  return http.post<ICourseAnalysis>(urlActivitylist, {
    classId,
    ActivityType
  });
}

export const urlgetClassAllStuInfo = urlDesignFaceTeachActivity + 'getClassAllStuInfo';

export class getClassAllStuInfo {
  code: number;
  msg: string;
  studentlist: {
    Id: string,
    StudentId: string,
    StudentDisplayName: string,
    AvatorUrl: string
  }[];
}

export function GetClassAllStuInfo(classId: string, activityId: string, displayNamePiny: string) {
  return http.post<getClassAllStuInfo>(urlgetClassAllStuInfo, {
    classId,
    activityId,
    displayNamePiny
  });
}

export const urlgetClassAllStuInfoByTraditionSign = urlDesignFaceTeachActivity + 'getClassAllStuInfoByTraditionSign';

export class IgetClassAllStuInfoByTraditionSign {
  code: number;
  msg: string;
  studentlist: {
    Id: string,
    StudentId: string,
    StudentDisplayName: string,
    AvatorUrl: string
  }[];
}

export function getClassAllStuInfoByTraditionSign(classId: string, activityId: string, displayNamePiny: string) {
  return http.post<IgetClassAllStuInfoByTraditionSign>(urlgetClassAllStuInfoByTraditionSign, {
    classId,
    activityId,
    displayNamePiny
  });
}

export class notSignedStu {
  code: number;
  msg: string;
  notsignedlist: {
    Id: string,
    StudentId: string,
    StudyNumber: string,
    StudentDisplayName: string,
    AvatorUrl: string
  }[];
}

export function NotSignedStu(activityId: string) {
  return http.post<notSignedStu>(urlnotSignedStu, {
    activityId
  });
}

export function RemoveStartFaceTeachActivity(activityId: string) {
  return http.post<TemplateResultClass>(urlRemoveStartFaceTeachActivity, {
    activityId
  });
}

/*------------------------------------------------------------------------------------------------------------------------- */

export class SignStatic {
  code: number;
  msg: string;
  result: {
    signState1: number;
    signState2: number;
    signState3: number;
    signState4: number;
  };
}

export function getSignStatic(faceId: string, studentId?: string) {
  return http.post<SignStatic>(urlgetSignStatic, {
    faceId,
    studentId
  });
}

export class IgetStudentSigned {
  code: number;
  msg: string;
  signedState: {
    stuId: string;
    activityName: string;
    stuName: string;
    signState: number;
  };
}

export function getStudentSigned(activityId: string) {
  return http.post<IgetStudentSigned>(urlgetStudentSigned, {
    activityId
  });
}


//添加资源到目录
export const urlsavecourseprocesscellDoc="/api/XOrg/CourseSectionIndex/saveCourseProcessCellDoc"

export class IgetsaveCourseProcessCell {
  code: number;
  msg: string;
}

export function saveCourseProcessCellDoc(courseId: string,topicId:string,parentId:string,maxSortOrder:Number,docIds:string[]) {
  return http.post<IgetsaveCourseProcessCell>(urlsavecourseprocesscellDoc, {
    courseId,
    topicId,
    docIds,
    parentId,
    maxSortOrder
  });
}